module.exports = __webpack_public_path__ + "img/ad8d6a04dd7dae79177a4a1e136568de(1).98074565.svg";